import React from 'react';
import { connect } from 'react-redux';
import { Button, Modal, Form } from 'semantic-ui-react'
import AppComponent from './app_component'
import ConfirmModal from './confirm_modal'

import { getFormLabelTranslations } from '../helpers'

class NewEntryModal extends AppComponent {
  constructor(props){
    super(props)

    this.state.formData = {...this.props.risk}
    this.state.formError = { work_phase: false, activity: false, hazard: false, unwanted_event: false }
    this.state.formKeys = this.getRequiredFormKeys()
    this.state.showConfirmSubmit = false
    this.state.warningStyle = { color: 'red', fontWeight: 'bold' }
  }

  componentWillReceiveProps = (nextProps) => {
    var formData = this.state.formData
    formData.id = nextProps.risk.id
    this.setState({
      formData: formData,
    })
  }

  onInputChange = (evt, { value }) => {
    var { formData } = this.state
    if(evt.target.name.includes('work_phase')){
      formData = this.updateColumnsForEnabledLanguages(formData, value, "work_phase", "work_phase_or_ambient_exposure")
    }
    if(evt.target.name.includes('activity')) {
      formData = this.updateColumnsForEnabledLanguages(formData, value, "activity", "activity")
    }
    if(evt.target.name.includes('hazard')) {
      formData = this.updateColumnsForEnabledLanguages(formData, value, "hazard", "hazard")
    }
    if(evt.target.name.includes('unwanted_event')) {
      formData = this.updateColumnsForEnabledLanguages(formData, value, "unwanted_event", "unwanted_event")
    }
    this.setState({ formData })
  }

  renderFormInputs = () => {
    const { formData, formKeys } = this.state
    const formLabelTranslations = getFormLabelTranslations()
    var form = []

    formKeys.map((key, index)=>{
      let props = { rows: 2, key: index, label: formLabelTranslations[key], name: key, value: formData[key], onChange: this.onInputChange}
      this.addErrorIndicators(key, props)
      this.disableInputs(key, props)
      return form.push(<Form.TextArea {...props}/>)
    })
    
    return form
  }

  addErrorIndicators = (key, props) => {
    const { formError } = this.state
    if (key.includes('work_phase')) { props.error = formError.work_phase }
    else if (key.includes('activity')) { props.error = formError.activity }
    else if (key.includes('hazard')) { props.error = formError.hazard }
    else if (key.includes('unwanted_event')) { props.error = formError.unwanted_event }
  }

  disableInputs = (key, props) => {
    const { formData } = this.state
    if (formData.column==='activity' && key.includes('work_phase')) props.disabled = true
    if (formData.column==='hazard' && key.includes('work_phase')) props.disabled = true
    if (formData.column==='hazard' && key.includes('activity')) props.disabled = true
    if (formData.column==='unwanted_event' && key.includes('work_phase')) props.disabled = true
    if (formData.column==='unwanted_event' && key.includes('activity')) props.disabled = true
    if (formData.column==='unwanted_event' && key.includes('hazard')) props.disabled = true
  }

  updateColumnsForEnabledLanguages = (formData, value, key, default_key) => {
    const { enabled_languages: enabledLanguages } = this.props.instanceConfig;
    for (const language of enabledLanguages) {
      if (language === "English") {
        formData[default_key] = value;
      } else {
        formData[`${key}_${language.toLowerCase()}`] = value;
      }
    }
    return formData;
  } 

  onSubmit = () => {
    if(this.props.loading || this.hasInvalidValues()) {
      return
    }

    let { formData } = this.state
    var risk = {
      name: formData.activityGroup,
      hidden: formData.hidden,
      selected_risk_id: formData.id
    }

    var undesired_keys = ['activityGroup', 'column', 'id', 'hidden', 'languageName']
    undesired_keys.forEach(key => delete formData[key]);

    formData.risk_description = ""
    formData.consequences_description = ""
    formData.highest_rating = ""
    formData.actions = ""
    formData.manager = ""
    formData.effectiveness = ""
    formData.status = { "dueDate": null, "status": null }
    formData.effectiveness2 = ""
    formData.consequences = [
      { key: 'financial', value: null },
      { key: 'safety', value: null },
      { key: 'health', value: null },
      { key: 'environmental', value: null },
      { key: 'reputation', value: null },
      { key: 'legal', value: null },
      { key: 'community', value: null },
    ]
    formData.new_consequences = [
      { key: 'new_financial', value: null },
      { key: 'new_safety', value: null },
      { key: 'new_health', value: null },
      { key: 'new_environmental', value: null },
      { key: 'new_reputation', value: null },
      { key: 'new_legal', value: null },
      { key: 'new_community', value: null },
    ]
    formData.likelihood = { type: "", value: "" }
    formData.new_likelihood = { type: "", value: "" }

    risk.metadata = JSON.stringify(formData)

    this.props.onSubmit(risk)
  }

  confirmSubmit = () => {
    if(this.props.loading || this.hasInvalidValues()) {
      return
    }

    if(this.props.isTemplate) {
      return this.toggleConfirmSubmit(true)
    }

    this.onSubmit()

  }

  hasInvalidValues = () => {
    var { formData, formError, formKeys } = this.state
    formKeys.map((key)=>{
      if (key.includes('work_phase')) formError.work_phase = (formData[key].trim().length === 0)
      if (key.includes('activity')) formError.activity = (formData[key].trim().length === 0)
      if (key.includes('hazard')) formError.hazard = (formData[key].trim().length === 0)
      if (key.includes('unwanted_event')) formError.unwanted_event = (formData[key].trim().length === 0)
      return
    })

    this.setState({ formError })
  
    return (formError.work_phase || formError.activity || formError.hazard || formError.unwanted_event)
  }

  toggleConfirmSubmit = (show) => {
    this.setState({ showConfirmSubmit:show })
  }

  render() {
    return (
      <Modal size="tiny" open={ this.props.shown }>
        <Modal.Header>{ this.props.headerText }</Modal.Header>
        <Modal.Content>
          <Form>
            { this.renderFormInputs() }
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button color='teal' fluid size='medium' onClick={ () => this.confirmSubmit() } className="new-plan-button">
            {this.props.translations.submit_button}&nbsp;&nbsp;{this.props.loading && <i className="loading circle notched icon"></i>}
          </Button>
        </Modal.Actions>
        <i className="delete icon" onClick={ this.props.onClose }></i>
        {
          this.state.showConfirmSubmit &&
          <ConfirmModal
            open={this.state.showConfirmSubmit}
            header="Confirm Submit"
            message={
              <span>
                <span style={this.state.warningStyle}>WARNING: </span>
                <span>Are you sure that the information is exactly correct? Information <span style={this.state.warningStyle}>CANNOT</span> be edited or deleted after "Submit".</span>
              </span>
             }
            onProceed={()=>this.onSubmit()}
            translations={this.props.translations}
            close={()=>this.toggleConfirmSubmit(false)}
            yesLabel='Submit'
            noLabel='Back'
          />
        }
      </Modal>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    instanceConfig: state.instance.instanceConfig
  }
}

export default connect(mapStateToProps, {})(NewEntryModal);



// WEBPACK FOOTER //
// ./src/components/new_entry_modal.js